import { useState } from 'react';

import ShareReferralModal from '../components/modals/ShareReferralModal';
import { lazyAdModal } from './lazyAdModal';

const AD_MODALS = {
  shareReferral: ShareReferralModal,
  shareWithAdmin: lazyAdModal(() => import('../components/modals/ShareWithAdminModal')),
  shareForPremium: lazyAdModal(() => import('../components/modals/ShareForPremiumModal')),
};

/**
 * The modal a descriptor names, if it names one.
 *
 * Every ad card resolves the same key the same way and opens it the same way; only
 * the button around it differs, which is why the `<Modal …/>` element itself stays
 * in each card — three deliberately different shells.
 *
 * @param ad             the winning descriptor
 * @param onClick        the slot's click tracker, fired before the modal opens
 * @param componentName  names the card in the unregistered-key error
 */
export function useAdModal({ ad, onClick, componentName }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const Modal = ad.modal && AD_MODALS[ad.modal.key];
  if (ad.modal && !Modal) {
    console.error(
      `${componentName}: no modal registered for key "${ad.modal.key}" (ad "${ad.id}")`
    );
  }

  return {
    Modal,
    isModalOpen,
    openModal: () => {
      onClick?.();
      setIsModalOpen(true);
    },
    closeModal: () => setIsModalOpen(false),
  };
}
